<template>
    <div class="content_box el_form mobile_content">
        <div class="content overview ">
            <div class="top">
                <div class="title">
                    <span>工单创建人统计</span>
                </div>
                <div class="time_box">
                    <DatePicker :date="overviewTime" @dateSelect="dateSelect" :clearable="true"></DatePicker>
                </div>
            </div>
            <div class="area_box">
                <div class="order_problem">
                    <div class="pie">
                        <div class="source">
                            <div class="title subtitle">新建工单量占比</div>
                            <div class="pie_area data_area">
                                <div class="pie_box" ref="sourcePie">
                                </div>
                                <div class="dataNone pie_none"
                                    v-show="!this.orderData.create_list || this.orderData.create_list.length == 0">暂无数据
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="leaderboard">
                        <div class="title subtitle">工单完结率排行</div>
                        <el-table :data="orderData.end_list" :fit="true" style="width:100%">
                            <el-table-column label="排名" type="index"  width="100">
                            </el-table-column>
                            <el-table-column prop="create_name" label="工单创建人">
                            </el-table-column>
                            <el-table-column prop="create_num" label="新建工单量">
                            </el-table-column>
                            <el-table-column prop="run_num" label="受理中工单量">
                            </el-table-column>
                            <el-table-column prop="end_num" label="已完结工单量">
                            </el-table-column>
                            <el-table-column prop="end_per" label="完结率">
                            </el-table-column>
                        </el-table>
                        <!-- <div class="leaderboard_box data_area">
                            <div class="leaderboard_item" v-for="(item, i) in orderData.end_list"
                                :key="item + i + 214234">
                                <div class="label">
                                    <span class="serial" :class="'serial-' + (i + 1)">{{ i + 1 }}</span>
                                    <span class="name ellipsis">{{ item.create_name }}</span>
                                </div>
                                <span class="number">{{ item.create_num || 43243 }}</span>
                            </div>
                            <div class="dataNone leaderboard_none"
                                v-show="!orderData.end_list || orderData.end_list.length == 0">暂无数据</div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default ({
    name: 'overview',
    data() {
        return {
            product_id: '',
            product: [],
            overviewTime: [],
            getWorkProblemData: {
                start_time: 0,
                end_time: 0
            },
            orderData: {},
            total: 0,
        }
    },
    watch: {
        'overviewTime': function (nTime) {
            this.getWorkProblemData.start_time = nTime[0] || 0;
            this.getWorkProblemData.end_time = nTime[1] || 0;
            this.getWorkProblem();
        },
    },
    created() {
        this.overviewTime = this.setDate(7);
    },
    methods: {
        getWorkProblem() {
            this.api.getCreaterCount(this.getWorkProblemData).then(data => {
                this.orderData = data.data;
                this.initPie();
            })

        },
        dateSelect(date) {
            this.overviewTime = date ? [...date] : '';
        },
        initPie() {
            let sourceTotal = 0;
            let sourceData = [];
            for (let i = 0; i < this.orderData.create_list.length; i++) {
                if(i == 9) {
                    sourceData.push({ value: this.orderData.create_list[i].create_num, name: '其他', per: Number(this.orderData.create_list[i].create_per) });
                    sourceTotal += this.orderData.create_list[i].create_num;
                }else if(i > 9){
                    sourceData[9].value += this.orderData.create_list[i].create_num;
                    sourceData[9].per = (Number(sourceData[9].per) +  Number(this.orderData.create_list[i].create_per)).toFixed(2);
                    sourceTotal += this.orderData.create_list[i].create_num;
                }else {
                    sourceData.push({ value: this.orderData.create_list[i].create_num, name: this.orderData.create_list[i].create_name, per: this.orderData.create_list[i].create_per });
                    sourceTotal += this.orderData.create_list[i].create_num;
                }
                
            }
            var sourceChart = this.echarts.init(this.$refs.sourcePie);
            sourceChart.setOption(this.pieOption(sourceData, sourceTotal));
        },

        pieOption(data, total) {
            return {
                color: ['#507FF7', '#64DE2F', '#FF9841', '#9B56FF', '#46FAF8'],
                title: {
                    text: `{name|工单量}\n{val|${total}}`,
                    top: '40%',
                    left: this.$store.state.type == 'pc' ? '114' : '34px',
                    textStyle: this.$store.state.type == 'pc' ? {
                        rich: {
                            name: {
                                fontSize: 20,
                                color: '#666',
                                lineHeight: '30',
                                align: 'center'
                            },
                            val: {
                                fontSize: 20,
                                color: '#000',
                                lineHeight: '30',
                                align: 'center'
                            }
                        }
                    } : {
                        rich: {
                            name: {
                                fontSize: 14,
                                color: '#666',
                                lineHeight: '20',
                                align: 'center'
                            },
                            val: {
                                fontSize: 14,
                                color: '#000',
                                lineHeight: '20',
                                align: 'center'
                            }
                        }
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b0}: <br /> {d0} % '
                },
                legend: {
                    orient: 'vertical',
                    left: this.$store.state.type == 'pc' ? (window.innerWidth > '1350' ? '350px' : '280px') : '130px',
                    top: 'center',
                    itemWidth: 12,
                    itemHeight: 12,
                    icon: "circle",
                    itemGap: 16,
                    selectedMode: false,
                    formatter: (name) => {
                        let legendData;
                        for (let i = 0; i < data.length; i++) {
                            legendData = data[i];

                            if (data[i].name == name) {
                                legendData = data[i];
                                break;
                            }
                        }
                        if (legendData) {
                            const str = this.$store.state.type == 'pc' ? `${legendData.name} \t\t | \t\t\t\t\t\t\t${legendData.per} % \t\t\t\t\t\t\t${legendData.value}` : `${legendData.name} \t\t | \t\t${legendData.per} % \t\t${legendData.value}`;
                            return str;
                        }
                        return '';
                    }
                },
                series: [
                    {
                        name: '新建工单量占比',
                        type: 'pie',
                        center: this.$store.state.type == 'pc' ? ['150px', 'center'] : ['60px', 'center'],
                        radius: this.$store.state.type == 'pc' ? ['100', '70'] : ['60px', '40px'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            // borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                            position: 'center',
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '20'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data
                    }
                ]
            };
        },

    }
})
</script>
<style lang="less" scoped>
.content_box {
    padding: 0;
}

.overview {
    background: none;
    padding: 0;
    border-radius: 0;

    .background {
        background-color: @colorWhite;
    }

    .radius {
        border-radius: 24px;
    }

    .top {
        .flexLayout(space-between);
        padding: 20px;
        background-color: @colorWhite;
        .background();

        @media (max-width: 768px) {
            display: block;

            .title {
                margin-bottom: 12px;
            }
        }
    }

    .title {
        .el-select {
            width: 220px;
        }
    }

    .pie {
        height: 734px;
    }

    .area_box {
        height: calc(100% - 74px);

        .order_problem {
            .flexLayout(space-between, flex-start);
            flex-wrap: nowrap;
            padding: 20px;
            box-sizing: border-box;
            height: 100%;
            width: 100%;

            .pie {
                height: 100%;
                width: 50%;
                min-width: 550px;
                padding: 30px;
                flex: 1;
                box-sizing: border-box;
                .background();
                .radius();

                .pie_area {
                    .pie_box {
                        width: 100%;
                        min-height: 300px;
                    }
                }

            }

            .leaderboard {
                height: 100%;
                padding: 30px;
                box-sizing: border-box;
                margin-left: 20px;
                flex: 1;
                overflow-y: auto;
                .background();
                .radius();

                .title {
                    margin-bottom: 40px;
                }

                .dataNone {
                    padding-left: 50px;
                }

                .leaderboard_item {
                    .flexLayout(space-between);
                    font-size: 14px;
                    font-weight: 600;
                    margin-bottom: 30px;

                    .label {
                        .flexLayout(flex-start);
                    }

                    .serial {
                        @serialSIze: 24px;
                        display: inline-block;
                        width: @serialSIze;
                        height: @serialSIze;
                        line-height: @serialSIze;
                        border-radius: 50%;
                        text-align: center;
                        background: #F0F2F5;
                        color: #666;
                        font-weight: 500;
                        margin-right: 14px;

                        &.serial-1 {
                            background: #507FF7;
                            color: #fff;
                        }

                        &.serial-2 {
                            background: #507FF7;
                            color: #fff;
                            opacity: .8;
                        }

                        &.serial-3 {
                            background: #507FF7;
                            color: #fff;
                            opacity: .6;
                        }
                    }

                    .name {
                        color: #333;
                        max-width: 220px;
                    }
                }
            }

            @media (max-width: 768px) {
                flex-wrap: wrap;
                padding: 10px;
                height: auto;

                .pie {
                    padding: 0.1rem;
                    height: 350px;
                    margin-bottom: 15px;
                    border-radius: 9px;
                    min-width: 0;
                }

                .leaderboard {
                    padding: 0.1rem;
                    margin-left: 0;
                    min-width: 100%;
                    height: auto;
                    border-radius: 9px;

                    .title {
                        margin-bottom: 20px;
                    }

                    .leaderboard_item {
                        margin-bottom: 15px;
                    }

                    .leaderboard_none {
                        padding-left: 100px;
                        margin-top: 0;
                    }
                }
            }
        }

    }



}

.data_area {
    position: relative;

    .dataNone {
        background: #fff;
        color: rgba(0, 0, 0, .3);
        box-sizing: border-box;

        &.leaderboard_none {
            margin-top: 88px;
        }

        &.pie_none {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            padding-left: 100px;
            line-height: 200px;
        }

        &.line_none {
            padding-left: 0;
            text-align: center;
            line-height: 300px;
        }

        @media (max-width: 768px) {

            &.pie_none,
            &.leaderboard_none {
                line-height: 100px;
            }

        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/order/overview/creater-count.vue